import { connect } from 'react-redux'

import List from './List'
import { getFromSettings } from 'src/utils/helpers'
import { closeSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'
import { setRelatedDocumentsPolicy } from 'src/modules/Documents/actions'
import { setUploadFilePolicy } from 'src/modules/Documents/UploadFileForPolicy/actions'

const mapStateToProps = state => {
  return {
    currentlyOpenFeature: state.appReducer.currentlyOpenFeature,
    brand: getFromSettings(state, 'brand', {}),
    user: state.user.user,
  }
}

const mapDispatchToProps = {
  closeSidebar,
  setCurrentlyOpenFeature,
  setRelatedDocumentsPolicy,
  setUploadFilePolicy,
}

export default connect(mapStateToProps, mapDispatchToProps)(List)
